import React from 'react';
import { useTranslation } from 'react-i18next';
import { toTitleCase } from 'utils/string';
import './styles.css';
import { GoalCardsByIdResponse } from 'types/goalcard';
import { GsDate } from 'utils';
import Images from 'assets/img/Images';

interface PrintGoalcardProps {
  goalcardData: GoalCardsByIdResponse;
}

export const PrintGoalcard: React.FC<PrintGoalcardProps> = ({
  goalcardData,
}) => {
  const executeAtDate = goalcardData?.executeAt
    ? GsDate(goalcardData?.executeAt).format('MM/DD/YYYY')
    : undefined;

  const toTextTitle = toTitleCase(goalcardData?.whoIsCardFor);

  const fromTextTitle = toTitleCase(goalcardData?.investorFullName);

  const { t } = useTranslation();

  let wrapperClass = '';

  if (goalcardData?.description && goalcardData?.description.length > 250) {
    wrapperClass = 'print-goalcard-full-extended-container';
  } else if (
    goalcardData?.description &&
    goalcardData?.description.length >= 150
  ) {
    wrapperClass = 'print-goalcard-medium-extended-container';
  }

  return (
    <div className="print-goalcard">
      <div
        className={`print-goalcard-min-height print-goalcard-wrapper ${wrapperClass}`}
      >
        <div className="print-goalcard-inner">
          <div className="print-goalcard-header">
            <div className="print-goalcard-logo-wrapper">
              <img
                alt="goalsetter logo"
                className="print-goalcard-logo"
                src={Images.LOGO_PRINT}
              />
            </div>
            <h1 className="print-goalcard-heading">
              {`$ ${goalcardData?.amount.toFixed(2)}`}
            </h1>
          </div>
          <div className="print-goalcard-pic">
            <img
              alt="goalcard pic"
              id="cardImg"
              src={goalcardData?.goalcardImg}
            />
          </div>
          <div className="print-goalcard-body">
            <div className="print-goalcard-body-text">
              <div className="print-goalcard-body-info">
                <div className="print-goalcard-body-info-item to">
                  <div className="print-goalcard-body-info-item-label">
                    {t('printGoalcard.to')}
                  </div>
                  <div className="print-goalcard-body-info-item-value">
                    <span id="formNameTo">{toTextTitle}</span>
                  </div>
                </div>
                <div className="print-goalcard-body-info-item from">
                  <div className="print-goalcard-body-info-item-label">
                    {t('printGoalcard.from')}
                  </div>
                  <div className="print-goalcard-body-info-item-value">
                    <span id="formNameFrom">{fromTextTitle}</span>
                  </div>
                </div>
                <div className="print-goalcard-body-info-item for">
                  <div className="print-goalcard-body-info-item-label">
                    {t('printGoalcard.for')}
                  </div>
                  <div className="print-goalcard-body-info-item-value">
                    <span id="noGoalMessage">
                      {goalcardData?.internalDescription ||
                        t('printGoalcard.yourGoals')}
                    </span>
                  </div>
                </div>
              </div>
              <div
                className="print-goalcard-body-congrats"
                id="divMessage"
              >
                <h2 className="print-goalcard-body-congrats-heading">
                  {t('printGoalcard.hi')}{' '}
                  <span id="messageNameTo">{toTextTitle}</span>,
                </h2>
                <p
                  className="print-goalcard-body-congrats-par"
                  id="message"
                >
                  {' '}
                  {goalcardData?.description || t('printGoalcard.gotMoney')}
                </p>
                <span className="print-goalcard-body-congrats-sign">
                  <span id="messageNameFrom">{fromTextTitle}</span>
                </span>
              </div>
            </div>
            <div className="print-goalcard-body-photo">
              {goalcardData?.imageURL && (
                <img
                  id="uploadedImg"
                  alt="upload pic"
                  src={goalcardData?.imageURL}
                  className="uploaded-img"
                />
              )}
            </div>
          </div>
          <div className="print-goalcard-faq">
            <h3 className="print-goalcard-faq-q">
              {t('printGoalcard.whatIs')}
            </h3>
            <p className="print-goalcard-faq-a">
              {t('printGoalcard.descriptionTitle')}
            </p>
            <h3 className="print-goalcard-faq-q">
              {t('printGoalcard.howToRedeem')}
            </h3>
            <p className="print-goalcard-faq-a">
              {executeAtDate
                ? t('printGoalcard.goalcardReceivetoTitle')
                : t('printGoalcard.goalcardSentToTitle')}
              <span id="emailSend">{goalcardData?.receiverEmail}</span>
              {executeAtDate
                ? t('printGoalcard.goalcardClaimInfo2', { executeAtDate })
                : t('printGoalcard.goalcardClaimInfo')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
